import React from "react";
import IndeterminateButton from "../indeterminate-button/IndeterminateButton";
import styled from 'styled-components';

const cdnBaseUrl = 'https://cdn.evolutionpayroll.com/empty-state-assets';

export interface EmptyState {
    className?: string,
    onClick?: () => void,
    iconType?: 'default' | 'report' | 'employee',
    iconImage?: string,
    iconAltText: string
    emptyHeader: string,
    emptyMessage?: string,
    emptyButtonText?: string,
    fullPage?: string
}

export const EmptyState = ({ onClick, iconType, iconImage, iconAltText, emptyHeader, emptyMessage, emptyButtonText, fullPage}: EmptyState) => (
  <EmptyStateWrapper
    className={`text-center bg-white d-flex empty-state pt-5 pb-5 pl-0 pr-0 ${fullPage === 'true' ? "justify-content-center border-neutral-300 flex-column fullPage" : "flex-row align-items-center justify-content-flex-start notFull"}`}
    >
        <img
          src={ iconImage ? iconImage : `${cdnBaseUrl}/${iconType}-emptystate.svg` }
          alt={iconAltText}
        />
        <div className={fullPage === 'true' ? "text-center mt-2" : "text-left ml-1"}>
          <h1 className={`h4 font-weight-normal ${fullPage === 'true' ? "mb-3" : "m-0"}`}>
            {emptyHeader}
          </h1>

          <p className="text-muted m-0 mb-2">
            {emptyMessage}
          </p>

          {onClick !== undefined &&
            <IndeterminateButton color="primary" className="mx-auto" onClick={onClick}>
              {emptyButtonText}
            </IndeterminateButton>
          }
        </div>        
    </EmptyStateWrapper>
);

EmptyState.defaultProps = {
  fullPage: 'true',
  iconType: 'default'
}

export default EmptyState;

const EmptyStateWrapper = styled.div`
  img {
    object-fit: contain;
    height: 117px;
  }
  h1 {
    line-height: 28px;
  }
  p.text-muted {
    line-height: 24px;
  }

  &.fullPage {
    height: 75vh;

    img {
      height: 237px;
    }
  }
  &.notFull {
    // on smaller screens the image/content should stack - need important to override
    // bootstrap important on flex direction/content and text-align
    @media only screen and (max-width: 748px) {
      flex-direction: column !important;
      justify-content: center !important;

      .text-left {
        text-align: center !important;
      }
    }
  }
`;
